module.exports = __webpack_public_path__ + "images/summer-sale-bg-mobile.jpg";